import Link from 'next/link';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { BsCardChecklist, BsPeople, BsSearch } from 'react-icons/bs';
import { MdDateRange, MdLocationSearching, MdOutlineVolunteerActivism } from 'react-icons/md';
import { OpportunitiesWrapper } from '../../../styles/oppurtunities-style';
import { Container } from "../../../styles/oppurtunities-style";
import mainBg from '../../../public/images/assets/opportunityBg.jpg';
import { FaChevronDown, FaRegHandshake } from "react-icons/fa";
import { IoMusicalNotesOutline, IoTelescopeOutline } from "react-icons/io5";
import OpportunityCard from '../../../components/opportunity-card/opportunity-card';
import { EventCardContainer } from "../../../components/event-card/event-card-style";
import { OpportunityCardContainer } from '../../../components/opportunity-card/opportunity-card-style';
import { GiHabitatDome, GiSkills } from 'react-icons/gi';
import { VscSymbolMisc } from 'react-icons/vsc';
import { OpportunityContext } from '../../../contexts/OpportunityContext';
import { Configure, ExperimentalConfigureRelatedItems, Hits, Index, connectPagination, SortBy } from 'react-instantsearch-dom';
import InfiniteHits from '../../../components/opportunity-card/infinite-hits';
import useBranding from '../../../hooks/store/useBranding';
import { OpportunitySearchProvider } from '../../../contexts/typesense/OpportunitySearchContext';
import DebouncedSearchBoxResource from '../../../components/resources/debounced-search-resource';
import { useRouter } from 'next/router';
import moment from 'moment';
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { DateRange } from 'react-date-range';
import styled from 'styled-components';
import { renderToolTipOverlay } from "../../../components/my-cart/cart-info";


interface DatePicker {
    startDate: any;
    endDate: any;
    key: string;
}
const Opportunities = () => {
    const { facetFiltersWithBranding } = useBranding();
    const router = useRouter();
    const { agencyId } = router?.query;
    const [showDate, setShowDate] = useState(false);
    const dropdown = useRef(null);
    const DateWrapper = !showDate ? styled.div`
    .rdrDateDisplayWrapper{
     display:grid;
     place-item:center;
     width:332px;
     height:52px;   
    }
    .rdrMonthAndYearWrapper,.rdrMonth{
        display:none;
    }
    .rdrCalendarWrapper{
      display:block;
    }
    `: styled.div`
    z-index:20;
    background:#fff;
    
    `;

    const eventFilterList = [
        'All',
        'For you',
        'New',
        'Online',
        'Today',
        'This weekend',
        'Halloween',
        'Breast Cancer Awareness Month',
        "Veteran's Day",
        'Free',
        'Music',
        'Food & Drink',
        'Charity & Causes'
    ];
    const disciplineList = [
        "visual arts",
        "cinema arts",
        "literary arts",
        "music",
        "dance",
        "theater",
        "all",
        "other"
    ];
    const opportunityCategories = [
        { title: 'Call for Entry', icon: <FaRegHandshake size={22} color={'#F0553F'} /> },
        { title: 'Grant', icon: <BsCardChecklist size={22} color={'#F0553F'} /> },
        { title: 'Internship', icon: <BsPeople size={22} color={'#F0553F'} /> },
        { title: 'Job', icon: <IoTelescopeOutline size={22} color={'#F0553F'} /> },
        { title: 'Auditions', icon: <VscSymbolMisc size={22} color={'#F0553F'} /> },
        { title: 'Residencies', icon: <GiHabitatDome size={22} color={'#F0553F'} /> },
        { title: 'Skill-building', icon: <GiSkills size={22} color={'#F0553F'} /> },
        { title: 'Volunteer', icon: <MdOutlineVolunteerActivism size={22} color={'#F0553F'} /> }
    ];
    const [activeCategory, setActiveCategory] = useState('');
    const { opportunitys, filter, setFilter } = useContext(OpportunityContext);
    const [currentSelectedOpportunityType, setCurrentSelectedOpportunityType] = useState("");
    const [currentSelectedDiscipline, setCurrentSelectedDiscipline] = useState("");
    const [filteredDate, setFilteredDate] = useState<string>("");
    const [sortBy, setSortBy] = useState<string>()

    const [searchText, setSearchText] = useState("");
    const [facetFilters, setFacetFilters] = useState<string[]>(['status:approved']);
    const [state, setState] = useState<DatePicker[]>(
        [{
            startDate: new Date(moment(new Date()).format("YYYY-MM-DD")),
            endDate: new Date(moment(new Date()).add(12, 'months').format("YYYY-MM-DD")),
            key: 'selection'
        }]
    );
    const handleClear = () => {
        setSearchText("");
        setState(
            [{
                startDate: new Date(moment(new Date()).subtract(1, 'months').format("YYYY-MM-DD")),
                endDate: new Date(moment(new Date()).add(1, 'months').format("YYYY-MM-DD")),
                key: 'selection'
            }]
        );
        setCurrentSelectedDiscipline("");
        setCurrentSelectedOpportunityType("");
        setActiveCategory("");
        setCurrentSelectedDiscipline("");
        setCurrentSelectedOpportunityType("");
    }
    useEffect(() => {
        if (agencyId) {
            console.log("agency", agencyId, router?.query)
            setFacetFilters(prev => [...prev?.filter(item => !item?.includes("agencyId")), `agencyId:${agencyId}`]);
        }
    }, [agencyId]);

    useEffect(() => {
        if (state && state.length > 0 && state[0].startDate && state[0].endDate) {
            setFilter(
                {
                    startDate: moment(state?.[0]?.startDate).format('YYYY-MM-DD'),
                    endDate: moment(state?.[0]?.endDate).format('YYYY-MM-DD'),
                }
            );
        }
    }, [state]);
    useEffect(() => {
        if (currentSelectedOpportunityType?.length === 0) {
            setFacetFilters(prev => [...prev?.filter(item => !item?.includes("opportunityType"))]);
        } else {
            setFacetFilters(prev => [...prev.filter(pk => !pk?.includes(`opportunityType`)), `opportunityType:${currentSelectedOpportunityType}`])
        }
    }, [currentSelectedOpportunityType]);

    useEffect(() => {
        if (filteredDate == '' || undefined) {
            setFacetFilters(prev => [...prev?.filter(item => !item?.includes("date"))]);
        } else {
            setFacetFilters(prev => [...prev.filter(pk => !pk?.includes(`date`)), `date:${filteredDate}`])
        }
    }, [filteredDate]);

    useEffect(() => {
        if (currentSelectedDiscipline?.length === 0) {
            setFacetFilters(prev => [...prev?.filter(item => !item?.includes("discipline"))]);
        } else {
            setFacetFilters(prev => [...prev.filter(pk => !pk?.includes(`discipline`)), `discipline:${currentSelectedDiscipline}`])
        }
    }, [currentSelectedDiscipline]);

    console.log(facetFilters, "Sd")
    useEffect(() => {
        // only add the event listener when the dropdown is opened
        if (!showDate) return;
        function handleClick(event) {
            if (dropdown.current && !dropdown?.current?.contains(event.target)) {
                setShowDate(false);
            }
        }
        window.addEventListener("click", handleClick, { capture: true });
        // clean up
        return () => window.removeEventListener("click", handleClick, { capture: true });
    }, [showDate]);
    const OpportunityCategoryCard = ({ item }) => {
        return <div className={`opportunity-categories-item d-flex align-items-center cursor-pointer ${activeCategory == item.title ? 'border-primary' : ''}`} onClick={() => { setActiveCategory(activeCategory != item.title ? item.title : ''); setCurrentSelectedOpportunityType((item?.title == "Job") || (item?.title == "Internship") || (item?.title == "Volunteer") ? "job/internship/volunteer" : currentSelectedOpportunityType != item.title ? item.title : '') }}>
            <div className="opportunity-categories-item-left text-center h-100">
                {item.icon}
            </div>
            <div className="opportunity-categories-item-right h-100">
                <p className="mb-0 ps-2">{item.title}</p>
            </div>
        </div>
    }
    return (
        <OpportunitySearchProvider searchScope={"opportunity"} sortBy={sortBy} facetFilters={facetFilters}>
            <Container>
                <div className="header" style={{ backgroundImage: `url(${mainBg.src})` }}>
                    <div className='glassmorphic pt-2 pt-md-5'>
                        <div className="container pt-5">
                            <h1 className="big-title text-white">{`LOOKING FOR`}<br />
                                OPPORTUNITIES?
                            </h1>
                            <div className='col-md-8'>
                                <p className='text-white mid-title'>The Artist Opportunity Board features the latest local, state, and national arts opportunities, such as grants, fellowships, calls for entry, workshops, jobs, and more.</p>
                                <p className='text-white mid-title'>
                                    Browse by opportunity type or deadline or subscribe to the Artist Resource Newsletter to have the latest opportunities delivered straight to your inbox each month.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container mt-5">
                    <div className="bordered-card ps-4 d-md-flex justify-content-between">
                        <div>
                            <p className="bordered-card-title mb-1 cursor-pointer fa-color">
                                Submit artist opportunities here.
                            </p>

                            <span className="bordered-card-description">
                                For corrections to posted opportunities, please email opportunities@fresharts.org

                            </span>
                        </div>
                        <div className='mt-4 mt-md-0'>
                            <Link passHref href={`/m/opportunities/edit/${agencyId}`}>
                                <a>
                                    <button className='btn btn-ghost fa-ghost-btn'>Submit opportunity</button>
                                </a>
                            </Link>
                        </div>
                    </div>
                    <div className="opportunity-container mt-5">
                        <h2 className="location-based-opportunity-title mb-4">
                            Opportunities
                        </h2>
                        <div className='mb-4 mb-md-0 d-md-flex'>
                            <div className="position-relative rounded col-md-6 col-lg-4 mb-3 mb-md-0">
                                <DebouncedSearchBoxResource searchText={searchText} setSearchText={setSearchText} placeholder={'Search'} />
                            </div>
                            <div>
                                <select style={{ height: 50 }} className='form-select ms-md-2 py-3 py-md-0 capitalize' value={currentSelectedDiscipline} onChange={(e) => setCurrentSelectedDiscipline(e.target?.value)}>
                                    <option value={''}>All opportunities</option>
                                    {disciplineList?.map((value) => <option key={value} className='capitalize' value={value}>{value}</option>)}
                                </select>
                            </div>
                            <button onClick={() => handleClear()} className='d-none d-md-block ms-md-4 mt-3 mt-md-0 w-auto btn btn-green fa-btn text-align-right'>Clear</button>


                        </div>
                        <div className='d-flex justify-content-between align-items-center position-relative'>
                            <div className={`col-12 col-md-10 col-lg-4 d-flex align-items-start position-md-absolute mx-auto mx-lg-0`} style={{ left: 0, top: 20 }}>
                                <DateWrapper onClick={() => setShowDate(true)} ref={dropdown} className="mt-0">
                                    <DateRange

                                        editableDateInputs={true}
                                        onChange={item => { setState([item.selection]); }}
                                        moveRangeOnFirstSelection={false}
                                        retainEndDateOnFirstSelection={false}
                                        ranges={state}
                                        showPreview={false}
                                    />
                                </DateWrapper>
                                <span className="badge bg-grey mt-0" style={{ margin: 10, transform: 'translate(0,15px)' }}>
                                    {renderToolTipOverlay(
                                        "How to filter",
                                        "Click the start date to open the calendar, select the first date, then click the end date while the calendar is still open and select a second date."
                                    )}
                                </span>
                            </div>
                        </div>
                        <button onClick={() => handleClear()} className='d-md-none ms-md-4 mt-3 mt-md-0 w-auto btn btn-green fa-btn text-align-right'>Clear</button>

                        <div className="opportunity-categories mt-5 pt-md-5">
                            {/* <h2 className="categories-title mb-4">Check out trending categories</h2> */}
                            <div className="opportunity-categories-list">
                                {
                                    opportunityCategories?.map((value, index) => <OpportunityCategoryCard key={`${index}`} item={value} />)

                                }

                            </div>
                        </div>


                        <div className="location-based-opportunity mt-3">
                            <div className="opportunity-categories-list my-2">
                                <select className='form-select' onChange={(e) => {
                                    if (e.target.value == "closingsoon")
                                        setSortBy("date:asc")
                                    else if (e.target.value == "newlyadded") {
                                        setSortBy("lastUpdated:desc");
                                    }
                                    else
                                        setSortBy("date:asc")
                                }}>
                                    <option value="sortby">Sort by</option>
                                    <option value="closingsoon">Closing Soon</option>
                                    <option value="newlyadded">Newly added</option>
                                </select>
                            </div>
                            <OpportunityCardContainer className='mt-3'>
                                <div>
                                    <Configure numericFilters={(sortBy != "lastUpdated:desc" && filter && filter.startDate && filter.endDate) ? [`date >= ${moment(filter.startDate).add(-1, "day").valueOf()}`, `date <= ${moment(filter.endDate).add(1, "day").valueOf()}`] : []} hitsPerPage={20} facetFilters={facetFilters} />
                                    <InfiniteHits searchText={searchText} />
                                </div>
                            </OpportunityCardContainer>
                        </div>


                    </div>
                </div>
            </Container>
        </OpportunitySearchProvider>
    );
}
export default Opportunities;